export class DuplicateGuard {
    constructor(cooldownMs = 1200) {
        this.setCooldown(cooldownMs);
        this.lastSeen = new Map();
    }

    setCooldown(cooldownMs) {
        const parsed = Number(cooldownMs);

        if (!Number.isFinite(parsed) || parsed < 0) {
            throw new TypeError('O cooldown deve ser um número maior ou igual a zero.');
        }

        this.cooldownMs = parsed;
    }

    isDuplicate(value, timestamp = Date.now()) {
        const previous = this.lastSeen.get(value);
        const duplicate = (
            previous !== undefined
            && timestamp - previous < this.cooldownMs
        );

        if (!duplicate) {
            this.lastSeen.set(value, timestamp);
        }

        this.prune(timestamp);

        return duplicate;
    }

    prune(timestamp = Date.now()) {
        const retention = Math.max(this.cooldownMs * 4, 10000);

        for (const [value, seenAt] of this.lastSeen) {
            if (timestamp - seenAt > retention) {
                this.lastSeen.delete(value);
            }
        }
    }

    clear() {
        this.lastSeen.clear();
    }
}
